import axios from "axios";
import { 
    CREATE_BREED_ATTRIBUTE,
    UPDATE_BREED_ATTRIBUTE,
    DELETE_BREED_ATTRIBUTE,
    FETCH_BREED_ATTRIBUTES,
    interceptor
} from ".";

import store from "../store";
interceptor(axios, store);

export function createBreedAttribute(breedAttribute) {
    return {
      type: CREATE_BREED_ATTRIBUTE,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/createBreedAttribute`, breedAttribute, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function updateBreedAttribute(breedAttribute) { 
    return {
      type: UPDATE_BREED_ATTRIBUTE,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/updateBreedAttribute/${breedAttribute.id}`, breedAttribute, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function deleteBreedAttribute(selected) {
    return {
      type: DELETE_BREED_ATTRIBUTE,
      payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/deleteBreedAttribute/${selected}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function fetchBreedAttributes() {
    return {
      type: FETCH_BREED_ATTRIBUTES,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/getBreedAttributes/`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }